export const OCC_ENDPOINTS = {
  orderInvoicePayment: 'current-user/orders/${orderId}/pdf/OrderInvocePayment',
  repeatOrder: 'current-user/carts/${cartId}/add-order',
  repeatOfflineOrder: '/current-user/carts/${cartId}/add-offline-order',
  orderHistory: 'current-user/orders',
  orderDetail: 'current-user/orders/${orderId}',
  offlineOrdersHistory: 'current-user/offline-orders',
  offlineOrderDetails: 'current-user/offline-orders/${orderId}',
};
